module.exports = __webpack_public_path__ + "static/media/default-floorplan-banner.2f07b8ed.jpg";